import { useFieldArray } from 'react-hook-form';

export default ({ collectionName, control, register, formContext }) => {
  const { fields, remove, append } = useFieldArray({
    control: control,
    name: `openingHours.${collectionName}`,
  });
  return (
    <div className="sixteen wide column">
      <div className="sixteen wide column">
        {fields.map((item, index) => {
          return (
            <div key={item.id}>
              <div className="fields">
                <div className="ui labeled input">
                  <div className="ui label">Days Of Week</div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Monday"
                      type="checkbox"
                      placeholder="Monday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Monday"
                    />
                    <label htmlFor="Monday">Monday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Tuesday"
                      type="checkbox"
                      placeholder="Tuesday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Tuesday"
                    />
                    <label htmlFor="Tuesday">Tuesday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Wednesday"
                      type="checkbox"
                      placeholder="Wednesday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Wednesday"
                    />
                    <label htmlFor="Wednesday">Wednesday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Thursday"
                      type="checkbox"
                      placeholder="Thursday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Thursday"
                    />
                    <label htmlFor="Thursday">Thursday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Friday"
                      type="checkbox"
                      placeholder="Friday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Friday"
                    />
                    <label htmlFor="Friday">Friday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Saturday"
                      type="checkbox"
                      placeholder="Saturday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Saturday"
                    />
                    <label htmlFor="Saturday">Saturday</label>
                  </div>
                  <div className="ui checkbox" style={{ marginRight: '10px' }}>
                    <input
                      disabled
                      id="Sunday"
                      type="checkbox"
                      placeholder="Sunday"
                      name={`openingHours.${collectionName}[${index}].daysOfWeek`}
                      {...register(`openingHours.${collectionName}.${index}.daysOfWeek` as const)}
                      value="Sunday"
                    />
                    <label htmlFor="Sunday">Sunday</label>
                  </div>
                </div>
              </div>
              <div className="field">
                <div className="ui labeled input">
                  <div className="ui label">Is Open</div>
                  <select
                    disabled
                    name={`openingHours.${collectionName}[${index}].isOpen`}
                    {...register(`openingHours.${collectionName}.${index}.isOpen` as const)}>
                    <option>--Select if is open</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                </div>
              </div>
              <div className="field">
                <div className="ui labeled input">
                  <div className="ui label">Start Hour</div>
                  <input
                    disabled
                    name={`openingHours.${collectionName}[${index}].startHour`}
                    {...register(`openingHours.${collectionName}.${index}.startHour` as const)}
                  />
                </div>
              </div>

              <div className="field">
                <div className="ui labeled input">
                  <div className="ui label">End Hour</div>
                  <input
                    disabled
                    name={`openingHours.${collectionName}[${index}].endHour`}
                    {...register(`openingHours.${collectionName}.${index}.endHour` as const)}
                  />
                </div>
              </div>
              <section>
                <button disabled className="negative mini ui button" type="button" onClick={() => remove(index)}>
                  delete {collectionName} opening hours
                </button>
                <h2 className="ui dividing header"></h2>
              </section>
            </div>
          );
        })}
      </div>
      <section>
        <h3 className="ui dividing header"></h3>
        <button
          disabled
          className="positive mini ui button"
          type="button"
          onClick={() => {
            var values = formContext.getValues(`openingHours.${collectionName}`);
            var allDays = 0;
            values.forEach((a) => {
              if (a.daysOfWeek.length) {
                allDays = allDays + a.daysOfWeek.length;
              }
            });
            if (allDays >= 7) {
              alert('All week days have configuration, no need to add new ones.');
              return;
            }

            append(null);
          }}>
          add {collectionName} opening hour
        </button>
      </section>
    </div>
  );
};
